import React from 'react';
import PropTypes from 'prop-types';

import Input from 'components/bronson/Input';

import { validateDocumentId } from 'Functions';

const UserData = ({ t, values, setFieldValue, renderError, disabled }) => {
    return (
        <div
            className="u-mb-large u-flex u-flex-start"
            style={{
                flexWrap: 'wrap',
            }}
        >
            <h5 className="u-1/1 u-mb-large">{t.getTraduction('FillData')}</h5>
            <div className="u-1/2 u-1/1@s u-inline-item u-pr u-pr-none@s u-mb">
                <Input
                    options={{
                        id: 'documentId-input',
                        type: 'text',
                        event: false,
                        label: `${t.getTraduction(
                            'IdentificationDocuments'
                        )} ${t.getTraduction('Comprador')}`,
                        disabled: true,
                    }}
                    value={values.documentId}
                    onChange={value => setFieldValue('documentId', value)}
                />
                {renderError('documentId')}
            </div>
            {validateDocumentId(values.documentId) === 2 ? (
                <div className="u-1/2 u-1/1@s u-inline-item u-pl u-pl-none@s u-mb">
                    <Input
                        options={{
                            id: 'business-input',
                            type: 'text',
                            event: false,
                            label: t.getTraduction('Business'),
                            disabled,
                        }}
                        value={values.business}
                        onChange={value => setFieldValue('business', value)}
                    />
                    {renderError('business')}
                </div>
            ) : (
                <>
                    <div className="u-1/2 u-1/1@s u-inline-item u-pl u-pl-none@s u-mb">
                        <Input
                            options={{
                                id: 'name-input',
                                type: 'text',
                                event: false,
                                label: t.getTraduction('Name'),
                                disabled,
                            }}
                            value={values.name}
                            onKeyPress={e =>
                                e.key.match(
                                    /[0-9$-/:-?{-~!"^_`\\[\]¡¿¬#·€@]/
                                ) && e.preventDefault()
                            }
                            onChange={value => setFieldValue('name', value)}
                        />
                        {renderError('name')}
                    </div>
                    <div className="u-1/2 u-1/1@s u-inline-item u-pr u-pr-none@s u-mb">
                        <Input
                            options={{
                                id: 'firstSurname-input',
                                type: 'text',
                                event: false,
                                label: t.getTraduction('Surname'),
                                disabled,
                            }}
                            value={values.firstSurname}
                            onKeyPress={e =>
                                e.key.match(
                                    /[0-9$-/:-?{-~!"^_`\\[\]¡¿¬#·€@]/
                                ) && e.preventDefault()
                            }
                            onChange={value =>
                                setFieldValue('firstSurname', value)
                            }
                        />
                        {renderError('firstSurname')}
                    </div>
                    <div className="u-1/2 u-1/1@s u-inline-item u-pl u-pl-none@s u-mb">
                        <Input
                            options={{
                                id: 'secondSurname-input',
                                type: 'text',
                                event: false,
                                label: t.getTraduction('Surname2'),
                                disabled,
                            }}
                            value={values.secondSurname}
                            onKeyPress={e =>
                                e.key.match(
                                    /[0-9$-/:-?{-~!"^_`\\[\]¡¿¬#·€@]/
                                ) && e.preventDefault()
                            }
                            onChange={value =>
                                setFieldValue('secondSurname', value)
                            }
                        />
                        {renderError('secondSurname')}
                    </div>
                </>
            )}
            <div className="u-1/2 u-1/1@s u-inline-item u-pr u-pr-none@s u-mb">
                <Input
                    options={{
                        id: 'phone-input',
                        type: 'number',
                        event: false,
                        label: `${t.getTraduction('PlaceHolderPhone')} 1`,
                        disabled,
                    }}
                    value={values.phone}
                    onKeyPress={e =>
                        (values.phone.length > 13 || e.key.match(/[^0-9]/)) &&
                        e.preventDefault()
                    }
                    onChange={value => setFieldValue('phone', value)}
                />
                {renderError('phone')}
            </div>
            <div className="u-1/2 u-1/1@s u-inline-item u-pl u-pl-none@s u-mb">
                <Input
                    options={{
                        id: 'secondaryPhone-input',
                        type: 'number',
                        event: false,
                        label: `${t.getTraduction(
                            'PlaceHolderPhone'
                        )} 2 (${t.getTraduction('Optional')})`,
                        disabled,
                    }}
                    value={values.secondaryPhone}
                    onKeyPress={e =>
                        (values.secondaryPhone.length > 13 ||
                            e.key.match(/[^0-9]/)) &&
                        e.preventDefault()
                    }
                    onChange={value => setFieldValue('secondaryPhone', value)}
                />
                {renderError('secondaryPhone')}
            </div>
            <div className="u-1/2 u-1/1@s u-inline-item u-pr u-pr-none@s u-mb">
                <Input
                    options={{
                        id: 'email-input',
                        type: 'text',
                        event: false,
                        label: `${t.getTraduction('PlaceHolderEmail')} 1`,
                        disabled,
                    }}
                    value={values.email}
                    onChange={value => setFieldValue('email', value)}
                />
                {renderError('email')}
            </div>
            <div className="u-1/2 u-1/1@s u-inline-item u-pl u-pl-none@s u-mb">
                <Input
                    options={{
                        id: 'secondaryEmail-input',
                        type: 'text',
                        event: false,
                        label: `${t.getTraduction(
                            'PlaceHolderEmail'
                        )} 2 (${t.getTraduction('Optional')})`,
                        disabled,
                    }}
                    value={values.secondaryEmail}
                    onChange={value => setFieldValue('secondaryEmail', value)}
                />
                {renderError('secondaryEmail')}
            </div>
        </div>
    );
};

UserData.propTypes = {
    t: PropTypes.shape({
        getTraduction: PropTypes.func.isRequired,
    }),
    setFieldValue: PropTypes.func.isRequired,
    renderError: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    values: PropTypes.object,
};

export default UserData;
